
export function DemoTestimonialsSection() {
  const testimonials = [
    {
      quote: "The demo showed exactly what we needed - simple, effective protection that our team could actually use. Within a week of implementation, we caught three phishing attempts that would have cost us thousands.",
      author: "Sarah Mitchell",
      role: "Operations Director",
      company: "Manchester Marketing Ltd",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b9e3?w=80&h=80&fit=crop&crop=face"
    },
    {
      quote: "As a small business owner, I was skeptical about cybersecurity solutions being too complex. Driscop's demo proved me wrong - it's incredibly user-friendly and the dashboard gives me peace of mind.",
      author: "James Thompson",
      role: "Founder & CEO",
      company: "Thompson Consulting",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face"
    },
    {
      quote: "The real-time training nudges are brilliant. Our employees actually learn from their mistakes instead of just being told off. The demo convinced us immediately.",
      author: "Emma Roberts",
      role: "HR Manager",
      company: "Roberts & Associates",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              What UK Businesses Say After the Demo
            </h2>
            <p className="text-xl text-gray-400">
              Real feedback from SME owners who've seen Driscop in action
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gray-800/50 p-8 rounded-xl border border-gray-700">
                <div className="flex items-center mb-6">
                  <div className="flex text-yellow-400 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                </div>
                <blockquote className="text-gray-400 mb-6 leading-relaxed">
                  "{testimonial.quote}"
                </blockquote>
                <div className="flex items-center">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.author}
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  />
                  <div>
                    <div className="font-semibold text-white">
                      {testimonial.author}
                    </div>
                    <div className="text-sm text-gray-400">
                      {testimonial.role}
                    </div>
                    <div className="text-sm text-blue-400">
                      {testimonial.company}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
